<template>
	<div class="modal-column">
		<Loading text="损益检查中..." :loading="loading"></Loading>
		<div class="flex-1 m-8px">
			<Row :space="9">
				<Cell width="8" v-for="(type,i) in templateList" :key="i">
					<!-- 当id是9999的则表示这条是结转损益的，其他的还走原来的结转模版 -->
					<div class="text-hover" v-if="type.id=='9999'">
						<div style="display: flex;justify-content: left;">
							<!-- <button @click="msg()" class="h-btn h-btn-primary h-btn-circle h-btn-group-xsss"><i class="h-icon-edit"></i><span></span></button> -->
							<!-- <button @click="msg()" class="h-btn h-btn-primary h-btn-circle h-btn-group-xsss"><i class="h-icon-trash"></i><span></span></button> -->
							<button @click="msgModel=true" class="h-btn h-btn-red h-btn-circle h-btn-group-xsss"><i class="h-icon-help"></i><span></span></button>
						</div>
						<p class="text-16px"><b>{{ type.title }}</b></p>
						<div class="calendarss">
							<p class="pnumber">&nbsp</p>
							<button @click="check" class="h-btn h-btn-red h-btn-group-xsssx">结转损益</button>
						</div>
					</div>
					<div class="text-hover" v-else>
            			<!-- <vxe-button @click="editClick(type)">编辑</vxe-button> -->
						<div style="display: flex;justify-content: left;">
							<button @click="editClick(type)" class="h-btn h-btn-primary h-btn-circle h-btn-group-xsss"><i class="h-icon-edit"></i><span></span></button>
							<button @click="delClick(type)" class="h-btn h-btn-primary h-btn-circle h-btn-group-xsss"><i class="h-icon-trash"></i><span></span></button>
						</div>
						<!-- <Button  @click="editClick(type)" icon="h-icon-search" color="primary"></Button> -->
						<p class="text-16px"><b>{{ type.title }}</b></p>
						<div class="calendarss">
							<template v-if="type.hasVoucher">
								<p class="pnumber">{{ type.amount }}</p>
								<router-link width="1024px" tag="button" :to="{name:'CheckoutVoucher', params: { voucherIdList:type.voucherIdList,checkoutTplId:type.id}}" class="h-btn h-btn-green h-btn-group-xsssx">查看凭证</router-link>
							</template>
							<template v-else>
								<p class="pnumber">{{ type.amount }}</p>
								<!-- jxd  'originPage':'profitPage'穿这个参数，代表这是结转凭证，不需要对损益类科目填写方向进行判断 -->
								<router-link @success="loadTemplateList" width="1120px" tag="button" :to="{name:'VoucherForm', params: { checkData,type,'originPage':'profitPage' }}" class="h-btn h-btn-primary h-btn-group-xsssx">生成凭证</router-link>
							</template>
						</div>
					</div>
				</Cell>
				<div class="new-btn text-hover" @click="editClick()"></div>
			</Row>
		</div>
		<div class="modal-column-btn">
			<Button :loading="loading" @click="check">下一步</Button>
		</div>
		<!-- 结转损益提示语 -->
		<Modal v-model="msgModel" v-bind="paramsStyle">
          <div style="margin-bottom: 10px;font-size: 16px;">小贴士：</div>
          <div>
			<p>每月的损益，以及年度结转都是自动进行的，只需要点击下一步系统会自动计算。</p>
		  </div>
          <div style="margin-top:10px ;display: flex;justify-content: right;">
            <vxe-button @click="msgModel=false" content="确定"/>
          </div>
        </Modal>
	</div>
</template>

<script>
export default {
	name: "ClosingCarryover"
}
</script>

<script setup>
import CheckTemp from "@/api/CheckTemp";
import checkout from "@api/checkout";
import {useStore} from "vuex";
import {h, ref} from "vue";
import {message} from "heyui.ext";
import {confirm} from "heyui.ext";
import {layer} from "@layui/layer-vue";
import VoucherForm from "@/views/voucher/VoucherForm.vue";
import CheckoutTemplateForm from "@/views/checkout/CheckoutTemplateForm.vue";

const props = defineProps(['checkData']);
const emits = defineEmits(['check', 'profitCheckList', 'back', 'profit', 'close','yearCheck','yearChecks']);
const store = useStore();
const currentAccountSetsId = store.state.currentAccountSets.id;

const templateList = ref([])
const loading = ref(false)
const msgModel = ref(false)

const loadTemplateList = () => {
	checkout.templateList(props.checkData.checkYear, props.checkData.checkMonth).then(({data}) => {
		let obj = {
			"id": "9999",
			"title": "结转损益",
		}
		data.push(obj);
    	templateList.value = data;
	})
}
loadTemplateList();

const check = () => {
	loading.value = true;
	//判断是否需要结转损益
	checkout.profitCheck(props.checkData.checkYear, props.checkData.checkMonth).then(({data}) => {
		// // console.log(data)
		// console.log(data.voucherItems)
		// // data.voucherItems[0].balance = 88888
		// console.log(data.voucherItems[0].balance)
		if (data.voucherItems && data.voucherItems.length) {
			let layerId = layer.drawer({
				title: props.checkData.checkYear + "年" + props.checkData.checkMonth + "期-结转损益",
				shadeClose: false,
				zIndex: 999,
				area: ['1120px', '100vh'],
				content: h(VoucherForm, {
					checkData: props.checkData,
					originPage:"profitPage",//结转损益调用弹出VoucherForm，将弹出页名称传递给VoucherForm
					profitCheckData: data.voucherItems,
					baseCheck:"baseCheck",//常规结转损益aas
					onSuccess: () => {
						if (props.checkData.checkMonth!=12) {
							// layer.close(layerId);
							// emits('check', props.checkData);
							setTimeout(()=>{
								layer.close(layerId);
								emits('check', props.checkData);
							},5000)
						}else {
							setTimeout(()=>{
							layer.close(layerId);
							emits('yearCheck', {checkData: props.checkData});
							},5000)
						}
					},
					onClose: () => {
						layer.close(layerId);
					}
				})
			})
		} else if (data.voucherIds && data.voucherIds.length) {
     		emits('profitCheckList', {checkData: props.checkData, voucherIds: data.voucherIds});
		} else {
			message.success("本期不需要结转损益~");
			if (props.checkData.checkMonth!=12) {
				emits('check', props.checkData);
			}else {
				setTimeout(()=>{
				emits('yearCheck', {checkData: props.checkData});
				},600)
			}
		}
	}).finally(() => loading.value = false)
}

const editClick = (temp = null) =>{
  let layerId = layer.drawer({
    title: temp ? "编辑模版" : "新增模版",
    shadeClose: false,
    zIndex: 999,
    area: ['1024px', '100vh'],
    content: h(CheckoutTemplateForm, {
      entity:temp,
      subjectList: [],
      originalSubjectList:[],//接口返回的原始科目列表jxd
      voucherWordList: [],
      accountSetsId: temp ? temp.accountSetsId : currentAccountSetsId.value,
      onSuccess: () => {
        message.success("保存成功~");
        loadTemplateList()
        layer.close(layerId);
      },
      onClose: () => {
        layer.close(layerId);
      }
    })
  })
}
const delClick = (temp) =>{
	confirm({
		content: `确认删除这个模版记录?`,
		onConfirm: () => {
			loading.value = true;
			CheckTemp.delete(Object.assign(temp.id)).then(() => {
				message.success("删除成功~");
				loadTemplateList()
			}).finally(() => {
				loading.value = false;
			})
		}
	})
}
</script>

<style lang="less" scoped>
.h-row > div > div {
	padding: 8px;
	color: #000;
	border-radius: 3px;
	text-align: center;
	background-color: #Fff;
	height: 150px;
	line-height: 36px;
	border: 1px solid #eee;
}

.pnumber {
	margin: 5px 0;
	font-size: larger;
}
.h-btn-group-xsss{
	padding:4px;
	width: 24px;
}
.text-hover{
	display: flex;
	flex-direction: column;
}
.h-btn-group-xsssx{
	width: 180px;
}
.new-btn{
	background-image: url(../../assets/add-new.default.png);
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	width: auto;
	padding: 4px;
	margin: 8px 0;
	height: 150px;
}
</style>

